import React from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const Table = ({ columns, dataSource, pagination, margin, style, ...otherProps }) => {
  return (
    <TableContainer sx={{ overflow: 'auto' }}>
      <MuiTable {...otherProps}>
        <TableHead>
          <TableRow>
            {columns?.map((column) => (
              <TableCell
                key={column.key}
                className={column.className}
                sx={{ margin: 0, padding: 0 }}
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataSource?.map((row, index) => (
            <TableRow
              className={`${row.subhead ? 'table--subhead' : ''} ${
                row.zebra ? 'table--zebra' : ''
              }`}
            >
              {columns?.map((column) => {
                const isHtmlString = typeof row[column.dataIndex] === 'string';

                return (
                  <>
                    {isHtmlString ? (
                      <TableCell
                        key={`${index}_${column.key}`}
                        className={column.className}
                        sx={{ margin: 0, padding: 0 }}
                        dangerouslySetInnerHTML={{
                          __html: row[column.dataIndex],
                        }}
                      />
                    ) : (
                      <TableCell
                        key={`${index}_${column.key}`}
                        className={column.className}
                        sx={{ margin: 0, padding: 0 }}
                      >
                        {column.render
                          ? column.render(row[column.dataIndex], row)
                          : row[column.dataIndex]}
                      </TableCell>
                    )}
                  </>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};

export default Table;
